/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { LoginAttemptFromJSON, LoginAttemptToJSON, } from './';
export function StringLoginAttemptDictionaryGenericApiResponseFromJSON(json) {
    return StringLoginAttemptDictionaryGenericApiResponseFromJSONTyped(json, false);
}
export function StringLoginAttemptDictionaryGenericApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : mapValues(json['content'], LoginAttemptFromJSON)),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}
export function StringLoginAttemptDictionaryGenericApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': value.content === undefined ? undefined : (value.content === null ? null : mapValues(value.content, LoginAttemptToJSON)),
        'errors': value.errors,
    };
}
